export default "__VITE_ASSET__92aba0c2__"